import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CurrentPContext, MasterContext, MobiOrNotContext } from '../ContextApi/context';
import utilsCategurys from '../_Utils/utilsCategurys';

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import ConnUrls from '../Connections/ConnectURL';
import MyFunctions from '../myFunctions';
import { Autoplay } from 'swiper';

const CatsLnksComp = () => {

  const [master, setMaster] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);


  const [categurs, setCategurs] = useState([]);
  const [swips, setSwips] = useState();

  useEffect(() => {

    loadCategurys();

  }, []);

  const loadCategurys = async () => {

    let cats = await utilsCategurys.getAllCategurys();

    cats = MyFunctions.sortAsc(cats, "catPosition");

    setCategurs(cats);

  }



  return (
    <div className={"FourMainLnksDiv"}>

      <Swiper
        reverseDirection={false}
        spaceBetween={mobiOrNot ? 4 : 8}
        slidesPerGroup={1}
        slidesPerView={mobiOrNot ? 4 : 8}
        loop={false}
        initialSlide={0}
        speed={3000}
        // onSlideChange={() => console.log('slide change')}
        freeMode={true}
        loopFillGroupWithBlank={true}
        height={mobiOrNot ? 500 : 1000}
        className={"catsSwiperDesktop"}

      >

        {
          [...categurs].reverse().map((item, index) => {
            return (
              <SwiperSlide key={index} className={mobiOrNot ? "catMasterBtn" : "NotcatMasterBtn"}>
                <Link to={`/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`}>
                  <div className={"catBtnMasterWrap animate__animated pulseME"}>
                    <img className={"prodImage"} src={`${ConnUrls.servMediasUrl}${item.catImage}`} alt={currentPage.altTags || currentPage.pageName || ""} />
                  </div>
                  <div className={"fourMastBtn pointing"} >
                    {item.catHead}
                  </div>
                </Link>
              </SwiperSlide>
            )

          })
        }


        {[...Array(mobiOrNot ? parseInt(categurs.length / 9) + 2 : parseInt(categurs.length / 18) + 2)].map((_, i) => (
          <SwiperSlide key={categurs.length + i + 1} className={"spacerfavBtn"}>
            <Link to="#">
              <div className={"catBtnMasterWrap animate__animated pulseME"}>
              </div>
              <div className={"fourMastBtn pointing"} >
              </div>
            </Link>
          </SwiperSlide>
        ))}

      </Swiper>


    </div>

  )

}

export default CatsLnksComp;



